import React, { useState } from 'react';
import { useCart } from '../context/CartContext';
import { Trash2Icon, PlusIcon, MinusIcon, ShoppingBagIcon, ArrowLeftIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckoutModal } from '../components/CheckoutModal';
export function Cart() {
  const {
    cart,
    removeFromCart,
    updateQuantity,
    cartTotal,
    cartCount
  } = useCart();
  const [checkoutOpen, setCheckoutOpen] = useState(false);
  if (cart.length === 0) {
    return <div className="min-h-[60vh] flex flex-col items-center justify-center px-4" data-id="element-363">
        <div className="w-20 h-20 bg-slate-50 rounded-full flex items-center justify-center mb-6 text-slate-300" data-id="element-364">
          <ShoppingBagIcon className="w-10 h-10" data-id="element-365" />
        </div>
        <h2 className="text-2xl font-black text-slate-900 mb-2 uppercase tracking-tight" data-id="element-366">
          Your cart is empty
        </h2>
        <p className="text-slate-500 mb-8" data-id="element-367">
          Looks like you haven't added any wellness essentials yet.
        </p>
        <Link to="/otc-products" className="bg-clinical-blue text-white font-bold py-4 px-8 rounded-xl hover:bg-blue-700 transition-all uppercase tracking-widest text-xs flex items-center gap-2" data-id="element-368">
          <ArrowLeftIcon className="w-4 h-4" data-id="element-369" /> Start Shopping
        </Link>
      </div>;
  }
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} className="bg-slate-50 min-h-screen py-12 sm:py-20" data-id="element-370">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-371">
        <h1 className="text-3xl sm:text-4xl font-black text-slate-900 mb-8 sm:mb-12 uppercase tracking-tighter" data-id="element-372">
          Your Shopping Cart
        </h1>

        <div className="grid lg:grid-cols-3 gap-8 sm:gap-12" data-id="element-373">
          <div className="lg:col-span-2 space-y-4" data-id="element-374">
            {cart.map(item => <div key={item.id} className="bg-white p-4 sm:p-6 rounded-2xl border border-slate-100 flex flex-col sm:flex-row gap-4 sm:gap-6 items-start sm:items-center" data-id="element-375">
                <div className="w-full sm:w-24 h-48 sm:h-24 rounded-xl bg-slate-50 overflow-hidden flex-shrink-0" data-id="element-376">
                  <img src={item.image} alt={item.name} className="w-full h-full object-cover" data-id="element-377" />
                </div>

                <div className="flex-grow w-full" data-id="element-378">
                  <h3 className="font-bold text-slate-900 mb-1" data-id="element-379">{item.name}</h3>
                  <p className="text-clinical-blue font-black mb-4" data-id="element-380">
                    {item.price}
                  </p>

                  <div className="flex items-center justify-between" data-id="element-381">
                    <div className="flex items-center border border-slate-200 rounded-lg overflow-hidden" data-id="element-382">
                      <button onClick={() => updateQuantity(item.id, -1)} className="p-2 hover:bg-slate-50 text-slate-500 transition-colors" data-id="element-383">
                        <MinusIcon className="w-4 h-4" data-id="element-384" />
                      </button>
                      <span className="px-4 font-bold text-slate-900 text-sm" data-id="element-385">
                        {item.quantity}
                      </span>
                      <button onClick={() => updateQuantity(item.id, 1)} className="p-2 hover:bg-slate-50 text-slate-500 transition-colors" data-id="element-386">
                        <PlusIcon className="w-4 h-4" data-id="element-387" />
                      </button>
                    </div>

                    <button onClick={() => removeFromCart(item.id)} className="text-slate-400 hover:text-red-500 transition-colors p-2" data-id="element-388">
                      <Trash2Icon className="w-5 h-5" data-id="element-389" />
                    </button>
                  </div>
                </div>
              </div>)}
          </div>

          <div className="lg:col-span-1" data-id="element-390">
            <div className="bg-white p-6 sm:p-8 rounded-2xl border border-slate-100 lg:sticky lg:top-32" data-id="element-391">
              <h2 className="text-xl font-black text-slate-900 mb-6 uppercase tracking-tight" data-id="element-392">
                Order Summary
              </h2>

              <div className="space-y-4 mb-8" data-id="element-393">
                <div className="flex justify-between text-slate-500 text-sm" data-id="element-394">
                  <span data-id="element-395">Subtotal ({cartCount} items)</span>
                  <span data-id="element-396">${cartTotal.toFixed(2)}</span>
                </div>
                <div className="flex justify-between text-slate-500 text-sm" data-id="element-397">
                  <span data-id="element-398">Shipping</span>
                  <span className="text-green-600 font-bold uppercase text-[10px] tracking-widest" data-id="element-399">
                    Calculated at checkout
                  </span>
                </div>
                <div className="pt-4 border-t border-slate-100 flex justify-between items-end" data-id="element-400">
                  <span className="text-slate-900 font-bold" data-id="element-401">Total</span>
                  <span className="text-2xl font-black text-clinical-blue" data-id="element-402">
                    ${cartTotal.toFixed(2)}
                  </span>
                </div>
              </div>

              <button onClick={() => setCheckoutOpen(true)} className="w-full bg-clinical-blue text-white font-black py-5 rounded-xl hover:bg-blue-700 transition-all uppercase tracking-widest text-xs shadow-lg shadow-clinical-blue/20" data-id="element-403">
                Proceed to Checkout
              </button>

              <p className="mt-6 text-center text-[10px] text-slate-400 uppercase tracking-widest font-bold" data-id="element-404">
                Secure SSL Encrypted Checkout
              </p>
            </div>
          </div>
        </div>
      </div>
      <CheckoutModal isOpen={checkoutOpen} onClose={() => setCheckoutOpen(false)} data-id="element-405" />
    </motion.div>;
}